import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet-async';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0); // Ensures page starts at top
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="privacy-page">
      <Helmet>
        <title>Privacy Policy | AzyByte Technologies</title>
        <meta
          name="description"
          content="Review the official Privacy Policy of AzyByte Technologies. Learn how we securely handle, protect, and manage user data across our digital solutions."
        />
        <link rel="canonical" href="https://www.azybyte.in/privacypolicy" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Privacy Policy | AzyByte Technologies" />
        <meta property="og:description" content="Official data privacy guidelines and protection standards for AzyByte Technologies." />
        <meta property="og:url" content="https://www.azybyte.in/privacypolicy" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />

      {/* Header Section */}
      <section className="bg-light text-dark py-5 mt-5">
        <div className="container pt-5 pb-4 text-center">
          <h1 className="fw-bold display-4" data-aos="fade-down">Privacy Policy - AzyByte</h1>
          <p className="opacity-75" data-aos="fade-up">Last Updated: April 25, 2026</p>
        </div>
      </section>

      {/* Policy Content */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 shadow-sm p-4 p-md-5 rounded-4 border bg-white" data-aos="fade-up">

              <div className="mb-5">
                <h3 className="fw-bold text-dark mb-3">1. Introduction</h3>
                <p className="text-muted leading-relaxed">
                  Welcome to <strong>AzyByte Technologies</strong> ("we," "our," or "us"). We are committed to protecting your privacy and ensuring your personal and business information is handled safely and responsibly. This Privacy Policy explains how we collect, use, and safeguard your data when you visit our website or engage us for IT services, software development, and automation solutions.
                </p>
              </div>

              <hr className="my-4 opacity-25" />

              <div className="mb-5">
                <h3 className="fw-bold text-dark mb-3">2. Information We Collect</h3>
                <p className="text-muted">We may collect the following types of information when you interact with our website or submit project inquiries:</p>
                <ul className="list-group list-group-flush mb-3">
                  <li className="list-group-item border-0 ps-0"><i className="bi bi-check2-circle text-primary me-2"></i><strong>Contact Information:</strong> Name, email address, phone number, and company name.</li>
                  <li className="list-group-item border-0 ps-0"><i className="bi bi-check2-circle text-primary me-2"></i><strong>Project Data:</strong> Requirements, business logic, system credentials, and other information necessary to execute the agreed-upon digital services.</li>
                  <li className="list-group-item border-0 ps-0"><i className="bi bi-check2-circle text-primary me-2"></i><strong>Technical Data:</strong> IP addresses, browser types, and standard analytics data collected via cookies to improve website performance.</li>
                </ul>
              </div>

              <div className="mb-5">
                <h3 className="fw-bold text-dark mb-3">3. How We Use Your Information</h3>
                <p className="text-muted">We use the collected information strictly for the following business purposes:</p>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item border-0 ps-0"><i className="bi bi-arrow-right-short text-primary me-2"></i>To provide, maintain, and deliver our software and IT solutions.</li>
                  <li className="list-group-item border-0 ps-0"><i className="bi bi-arrow-right-short text-primary me-2"></i>To communicate with you regarding project updates, invoices, and support.</li>
                  <li className="list-group-item border-0 ps-0"><i className="bi bi-arrow-right-short text-primary me-2"></i>To respond to your direct inquiries and consultation requests.</li>
                </ul>
              </div>

              <div className="mb-5">
                <h3 className="fw-bold text-dark mb-3">4. Data Sharing & Disclosure</h3>
                <p className="text-muted mb-3">
                  We do not sell, trade, or rent your personal or business data to third-party marketers.
                </p>
                <div className="p-3 bg-light rounded-3 border-start border-primary border-4">
                  <p className="mb-0 small text-muted">
                    To execute complex IT projects, we may share necessary project-specific details with our trusted network of independent technical contractors. All such personnel are strictly bound by <strong>Non-Disclosure Agreements (NDAs)</strong>. We may also share data with third-party infrastructure providers (e.g., cloud hosting) as required to deploy your solutions.
                  </p>
                </div>
              </div>

              <div className="mb-5">
                <h3 className="fw-bold text-dark mb-3">5. Data Security</h3>
                <p className="text-muted">
                  We implement industry-standard security measures (including encryption and secure protocols) to protect your data from unauthorized access or alteration. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="fw-bold text-dark mb-3">6. Contact Us</h3>
                <p className="text-muted">If you have any questions or concerns regarding this Privacy Policy, please reach out to us:</p>
                <div className="row g-3 mt-2">
                  <div className="col-md-6">
                    <div className="p-3 border rounded">
                      <h6 className="fw-bold mb-1">Email</h6>
                      <p className="mb-0 text-primary">contact@azybyte.in</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 border rounded">
                      <h6 className="fw-bold mb-1">Location</h6>
                      <p className="mb-0 text-muted">Gujarat, India</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;